<template>
  <b-card>
    <validation-observer
      ref="infoRules"
      v-slot="{ invalid }"
      tag="form"
    >
      <b-row>
        <b-col md="6">
          <b-form-group label="Standard Type">
            <!-- <b-form-input
              v-if="!$route.params.id"
              v-model="documentaryHalalForm.product_category_id"
              name="Standard Type"
              rules="required"
              class="w-100"
            /> -->
            <v-select
              v-model="documentaryHalalForm.product_category_id"
              class="w-100"
              :options="productList"
              :reduce="option => option.value"
            />
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group label="Documents">
            <b-form-textarea
              v-model="documentInput"
              type="text"
              placeholder="Type and press Enter"
              @keyup.enter.prevent="addDocument"
            />

          </b-form-group>
        </b-col>
        <b-col md="6" />
        <b-col md="6">

          <div class="mt-1 d-flex flex-column">
            <b-badge
              v-for="(item, index) in documentaryHalalForm.documents"
              :key="index"
              variant="primary"
              class="m-50 text-wrap"
              style="width: fit-content;"
            >
              {{ index + 1 }} - {{ item }}
              <feather-icon
                icon="TrashIcon"
                size="16"
                class="ml-50 cursor-pointer"
                color="black"
                @click="removeDocument(index)"
              />
            </b-badge>
          </div>
        </b-col>

        <!-- Server Errors -->
        <b-col
          v-if="Object.values(errors).length > 0"
          cols="12"
        >
          <p
            v-for="(error, key, index) in errors"
            :key="index"
            class="text-danger small"
          >
            {{ error.toString() }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="mt-50"
        >
          <b-button
            v-if="!loader && $route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="adddocumentaryHalal()"
          >
            Save Changes
          </b-button>
          <b-button
            v-if="!loader && !$route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="adddocumentaryHalal()"
          >
            Add
          </b-button>
          <b-button
            v-if="loader"
            variant="primary"
            disabled
            class="mr-1"
          >
            <b-spinner
              small
              type="grow"
            />
            Loading...
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>
  </b-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import formValidation from '@core/comp-functions/forms/form-validation'
import axios from 'axios'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import VSelect from 'vue-select'
import decryptData from '@/store/auth/decryptData'

export default {
  components: { VSelect },
  data() {
    return {
      required,
      loader: false,
      validationErrors: {},
      errors: {},
      documentInput: '',
      productList: [],
    }
  },
  setup() {
    const { getValidationState } = formValidation()
    // eslint-disable-next-line camelcase

    const documentaryHalalForm = ref({
      documents: [],
      product_category_id: '',
    })

    return {
      getValidationState,
      documentaryHalalForm,
    }
  },
  async  mounted() {
    this.listOfProduct()
    if (this.$route.params.id) {
      this.getDocumentaryHalalDetails()
    }
  },
  methods: {
    listOfProduct() {
      axios
        .get('halal/product-types')
        .then(res => {
          const productList = decryptData(res.data.payload).data
          this.productList = productList.productTypes.map(items => ({
            value: items.id,
            label: items.name,
          }))
        })
        .catch(error => {
          this.$toasted.show(error, {
            position: 'top-center',
            duration: 3000,
          })
        })
    },
    getDocumentaryHalalDetails() {
      axios
        .get(`halal/documentary-requirements/${this.$route.params.id}`)
        .then(res => {
          const documentary = decryptData(res.data.payload).data
          this.documentaryHalalForm = documentary
        })
        .catch(error => {
          this.$toasted.show(error, {
            position: 'top-center',
            duration: 3000,
          })
        })
    },

    addDocument() {
      if (!this.documentInput.trim()) return

      this.documentaryHalalForm.documents.push(
        this.documentInput.trim(),
      )
      this.documentInput = ''
    },

    removeDocument(index) {
      this.documentaryHalalForm.documents.splice(index, 1)
    },

    adddocumentaryHalal() {
      if (this.$route.params.id) {
        this.loader = true
        axios
          .put(`halal/documentary-requirements/${this.$route.params.id}`, this.documentaryHalalForm)
          .then(res => {
            if (res.status === 200) {
              this.$router.push({ name: 'halal-documentary-requirements' })
              this.$toasted.show('Updated Successfully', {
                position: 'top-center',
                duration: 3000,
              })
            }
          })
          .catch(error => {
            if (error.response.status) {
              const payload = decryptData(error.response.data.payload).message
              const firstArrayKey = Object.keys(payload).find(key => Array.isArray(payload[key]))
              const errorMessage = firstArrayKey ? payload[firstArrayKey][0] : 'An unknown error occurred'
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `${errorMessage}`,
                  icon: 'BellIcon',
                  variant: 'error',
                },
              })
            }
          })
          .finally(() => {
            this.loader = false
          })
      } else {
        this.loader = true
        const payloadData = { ...this.documentaryHalalForm }
        if (!this.$route.params.id) {
          payloadData.product_category_name = payloadData.product_category_id
          delete payloadData.product_category_id
        }
        axios
          .post('halal/documentary-requirements', payloadData)
          .then(res => {
            if (res.status === 200 || res.status === 201) {
              this.$router.push({ name: 'halal-documentary-requirements' })
              this.$toasted.show('Created Successfully', {
                position: 'top-center',
                duration: 3000,
              })
            }
          })
          .catch(error => {
            if (error.response.status) {
              const payload = decryptData(error.response.data.payload).message
              const firstArrayKey = Object.keys(payload).find(key => Array.isArray(payload[key]))
              const errorMessage = firstArrayKey ? payload[firstArrayKey][0] : 'An unknown error occurred'
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `${errorMessage}`,
                  icon: 'BellIcon',
                  variant: 'error',
                },
              })
            }
          })
          .finally(() => {
            this.loader = false
          })
      }
    },

  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
